<template>
    <label :class="disabled ? 'disabledRehabQ' : ''">
        <input type="checkbox" :checked="modelValue" @input="onChange">
        <Icon :name="modelValue ? 'checked' : 'unchecked'" /> <slot />
    </label>
</template>

<script lang="ts">
    import { Vue, Component, Prop } from 'vue-property-decorator';

    import Icon from '@/components/common/Icon.vue';

    // PRODUCT-26110 Task 12 (COMPONENT_V_MODEL): migrated to the Vue 3 v-model
    // contract (modelValue/update:modelValue). Consumed via v-model by ChargeDetails.vue.
    @Component({
        emits: [ 'update:modelValue' ],
        components: { Icon },
    })
    export default class ChargeCheckbox extends Vue {
        @Prop({ type: Boolean, default: false })
        private disabled!: boolean;

        @Prop({ type: Boolean, default: false })
        private modelValue!: boolean;

        private onChange() {
            this.$emit('update:modelValue', !this.modelValue);
        }
    }
</script>
